export default "__VITE_ASSET__d9626fc6__"